import { PropsWithChildren, FunctionComponent } from 'react';

interface MobilePageContentProps extends PropsWithChildren {}

const MobilePageContent: FunctionComponent<MobilePageContentProps> = ({ children }) => {
  return <div className="px-3 pb-10 flex-1 flex">{children}</div>;
};

export default MobilePageContent;
